import { Page, SidebarCollapseButton, Stack } from "@skailer-com/uikit";

export interface SidebarHeaderProps {
  title: string;
}

export function SidebarHeader({ title }: SidebarHeaderProps) {
  return (
    <Stack direction={"horizontal"} items={"center"} justify={"between"} className={"pr-6"}>
      <Page.Header title={title} />
      <SidebarCollapseButton variant={"secondary"} />
    </Stack>
  );
}
